export default "__VITE_ASSET__CxUM741n__"